export const DEFAULT_THEME = {
  background: "light",
  preference: "Custom",
  accentColor: "#FF00AB",
  colors: {
    group1color1: "#1D212E",
    group1color2: "#FFFFFF",
    group2color1: "#F2F6F6",
    group2color2: "#1D2641",
    group2color3: "#56A110",
    group3color1: "#FFFFFF",
    group3color2: "#162B51",
    group3color3: "#8D9AAE",
    group3color4: "#53a116",
    group4color1: "#CA0A0A",
    group4color2: "#DE9127",
    group4color3: "#2B880E"
  }
};

export function addStyleTheme(THEME) {
  return `
      form{
        display: grid;
      }

      .fp-hpc-pay-button{  
        width: 153px; 
        height: 46px; 
        margin: 20px 0 0 39px; 
        font-family: Lato;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        border-radius: 23px; 
        border: solid 1.5px ${THEME.colors.group3color4}; 
        background-color: ${THEME.colors.group1color2}; 
        color: ${THEME.colors.group3color2};
        justify-self: end;
      }
      
      .fp-hpc-pay-button:hover{
          background-color: rgba(141, 154, 174, 0.4); 
          border: solid 1.5px ${THEME.colors.group3color4};
          color: ${THEME.colors.group3color2};
      }
      
      label{ 
        height: 19px; 
        margin: 0 282px 8px 0; 
        font-family: Lato; 
        font-size: 16px; 
        font-weight: normal; 
        font-stretch: normal; 
        font-style: normal; 
        line-height: normal; 
        letter-spacing: normal; 
        color: ${THEME.colors.group3color2};
      }

      input{
        height: 46px;  
        border-radius: 2px; 
        border: solid 1px rgba(141, 154, 174, 0.4);
      }

      input:focus{
        border-radius: 2px;
        border: solid 2px ${THEME.colors.group3color4};
        box-shadow: none;
      }
    `;
}
